import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BadgeDollarSign, BadgePercent } from 'lucide-react';
import { colors, detailStyles } from './detail.styles';
import { parseAdjustmentEventMetadata } from './adjustmentActivityMetadata';
import { AdjustmentEventSummary } from './AdjustmentEventSummary';
export const AdjustmentAppliedActivity = ({ activity, metadata }) => {
    const event = parseAdjustmentEventMetadata(metadata);
    if (!event) {
        return (_jsx("div", { style: detailStyles.summaryRow, "data-testid": "adjustment-applied-fallback", children: _jsx("span", { style: detailStyles.summaryText, children: activity.description }) }));
    }
    const isDiscount = event.adjustmentType === 'discount';
    return (_jsxs("div", { style: detailStyles.detailContent, "data-testid": "adjustment-applied-detail", children: [_jsxs("div", { style: detailStyles.sectionHeader, children: [isDiscount ? (_jsx(BadgePercent, { size: 16, style: { color: colors.accent.red } })) : (_jsx(BadgeDollarSign, { size: 16, style: { color: colors.accent.green } })), _jsx("span", { children: isDiscount ? 'Discount applied' : 'Surcharge applied' })] }), _jsx(AdjustmentEventSummary, { event: event })] }));
};
export default AdjustmentAppliedActivity;
